import { render, staticRenderFns } from "./Taplist.vue?vue&type=template&id=4155a968&"
import script from "./Taplist.vue?vue&type=script&lang=js&"
export * from "./Taplist.vue?vue&type=script&lang=js&"
import style0 from "./Taplist.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports